export default "__VITE_ASSET__084c4689__"